<template>
  <div class="sl-table">
    <sl-table-row
      :is-header="true"
      v-bind="$props"
      :line-number="-1"
      @cell-click="$emit('cell-click', $event)"
      @cell-mouseover="$emit('cell-mouseover', $event)"
    />

    <sl-table-row
      v-for="(data, index) in datas"
      :key="'row_' + index"
      :ref="'row_' + index"
      :expand="expand"
      v-bind="$props"
      :datas="data"
      :line-number="index"
      @cell-click="$emit('cell-click', $event)"
      @cell-mouseover="$emit('cell-mouseover', $event)"
    />
  </div>
</template>

<script>
import SlTableRow from 'src/modules/shared/components/Table/SlTableRow';

/**
 * Tableau SwissLife
 * Un simple tableau pour afficher des données sans utiliser de composant de type q-table
 */
export default {
  name: 'SlTable',
  components: { SlTableRow },
  props: {
    // un identifiant de tableau
    tag: {
      type: String,
      required: true
    },
    // la description des colonnes ainsi que les fonctions de formatage
    columns: {
      type: Array,
      required: true
    },
    // les données organisées en simple tableau
    datas: {
      type: Array,
      required: true
    },
    currentPositionSelected: {
      type: Object,
      required: false
    },
    // l'écart +/- autour de la selection
    range: {
      type: Number,
      required: false,
    },
    expand: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'cell-click',
    'cell-mouseover'
  ]
}
</script>